import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 0A0E42BA-FE9D-44C6-BF6A-D29D6013F2E0
 * name note-multiple
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-multiple.svg
 * tags
 */
export const NoteMultipleIcon = createSvgIcon(<><path d="M16,9H21.5L16,3.5V9M7,2H17L23,8V18A2,2 0 0,1 21,20H7C5.89,20 5,19.1 5,18V4A2,2 0 0,1 7,2M3,6V22H21V24H3A2,2 0 0,1 1,22V6H3Z" /></>, 'NoteMultipleIcon');
export default NoteMultipleIcon